import { observer } from "mobx-react-lite";
import { CsvInputView } from "../view/csvInputView";

const CsvInput = observer(
    function CsvInputRender(props) {
        function goToTierlistACB() {
            window.location.hash = "#/tierlist";
        }
        function gotFileACB(file) {
            props.movieModel.parseCSVFile(file).then(goToTierlistACB);
        };
        return (
            <CsvInputView
                fileWasInputACB={gotFileACB}
            />
        );
    }
);

export { CsvInput };